import React, {Component, PropTypes} from 'react';
import {fetchOptimalleThemes} from "../../../data/api/api";
import ThemeSelect from "../../components/SearchForm/ThemeSelect";

class ThemeSelectContainer extends Component {

    static propTypes = {
        theme: PropTypes.string,
        onThemeChanged: PropTypes.func
    };

    state = {
        themes: []
    }

    componentDidMount() {
        fetchOptimalleThemes().then(response =>response.json())
            .then((themes) => {
            this.setState({
                themes : [{slug: 'null', id: 'null', title: "Tous les thèmes"}, ...themes]
            })
        })
    }

    handleSelect = (theme) => {
        this.props.onThemeChanged(theme)
    }

    render() {
        const { themes } = this.state;
        const { theme } = this.props;

        let defaultValue = {value: 'null', label: "Tous les thèmes"};
        if(theme){
            defaultValue = theme;
        }

        return <ThemeSelect onSelect={::this.handleSelect} themes={themes} theme={defaultValue}/>
    }
}

export default ThemeSelectContainer;